import { SelectedFilter, FilterChangeDetail } from './typing/filters-typing.js'
import { RangeFilterEventDetail } from 'components/discovery/plp/filters/range-filter/range-filter.js'

export class FilterRemovedEvent extends Event {
  static type = 'filter-removed' as const

  filter: SelectedFilter
  index: number

  constructor(filter: SelectedFilter, index: number) {
    super(FilterRemovedEvent.type, { bubbles: true, composed: true })
    this.filter = filter
    this.index = index
  }
}

export class FiltersClearedEvent extends Event {
  static type = 'filters-cleared' as const

  clearedFilters: SelectedFilter[]

  constructor(clearedFilters: SelectedFilter[]) {
    super(FiltersClearedEvent.type, { bubbles: true, composed: true })
    this.clearedFilters = clearedFilters
  }
}

export class PlpFiltersSelectedFiltersEvent extends Event {
  static type = 'plp-filters:selected-filters' as const

  selectedFilters: SelectedFilter[]
  filterUrl: string

  constructor(selectedFilters: SelectedFilter[], filterUrl: string) {
    super(PlpFiltersSelectedFiltersEvent.type, { bubbles: true, composed: true })
    this.selectedFilters = selectedFilters
    this.filterUrl = filterUrl
  }
}

export class PlpFiltersFavoritesToggleEvent extends Event {
  static type = 'plp-filters:favorites-toggle' as const

  checked: boolean
  filterUrl: string

  constructor(checked: boolean, filterUrl: string) {
    super(PlpFiltersFavoritesToggleEvent.type, { bubbles: true, composed: true })
    this.checked = checked
    this.filterUrl = filterUrl
  }
}

export class PlpFiltersCheckboxChangeEvent extends Event {
  static type = 'plp-filters:checkbox-change' as const

  change: FilterChangeDetail
  filterUrl: string

  constructor(change: FilterChangeDetail, filterUrl: string) {
    super(PlpFiltersCheckboxChangeEvent.type, { bubbles: true, composed: true })
    this.change = change
    this.filterUrl = filterUrl
  }
}

export class PlpFiltersRangeChangeEvent extends Event {
  static type = 'plp-filters:range-change' as const

  change: RangeFilterEventDetail
  filterUrl: string

  constructor(change: RangeFilterEventDetail, filterUrl: string) {
    super(PlpFiltersRangeChangeEvent.type, { bubbles: true, composed: true })
    this.change = change
    this.filterUrl = filterUrl
  }
}

declare global {
  interface GlobalEventHandlersEventMap {
    [FilterRemovedEvent.type]: FilterRemovedEvent
    [FiltersClearedEvent.type]: FiltersClearedEvent
    [PlpFiltersSelectedFiltersEvent.type]: PlpFiltersSelectedFiltersEvent
    [PlpFiltersFavoritesToggleEvent.type]: PlpFiltersFavoritesToggleEvent
    [PlpFiltersCheckboxChangeEvent.type]: PlpFiltersCheckboxChangeEvent
    [PlpFiltersRangeChangeEvent.type]: PlpFiltersRangeChangeEvent
  }
}
